import type { ModuleInjectionTable } from '@open-mercato/shared/modules/widgets/injection'

export const injectionTable: ModuleInjectionTable = {
  'sales.document.detail.order:tabs': [
    {
      widgetId: 'cargo.injection.order-cargo',
      kind: 'tab',
      groupLabel: 'cargo.widgets.orderCargo.tabLabel',
      priority: 70,
    },
  ],
  'sales.document.detail.quote:tabs': [
    {
      widgetId: 'cargo.injection.order-cargo',
      kind: 'tab',
      groupLabel: 'cargo.widgets.orderCargo.tabLabel',
      priority: 70,
    },
  ],
}

export default injectionTable
